import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import GlobalSearch from './GlobalSearch';
import NotificationBell from './NotificationBell';
import { C } from '../theme';

const TITLES = {
  '/dashboard': 'Dashboard', '/merchandising': 'Merchandising', '/order-execution': 'Order Execution',
  '/procurement': 'Procurement', '/vendor-review': 'Vendors', '/job-work': 'Job Work',
  '/production': 'Production', '/quality': 'Quality', '/finance': 'Finance', '/profitability': 'Profitability',
  '/performance': 'Performance', '/tasks': 'Tasks', '/masters': 'Masters', '/admin/users': 'Admin · Users',
  '/cost-estimation': 'Cost Estimation', '/tna': 'Time & Action', '/ie': 'Industrial Engineering',
  '/ppc': 'PPC', '/centre-board': 'Centre Board', '/production-bulletin': 'Production Bulletin',
};
const ROLE_LABEL = { admin: 'Admin', management: 'Management', merchandiser: 'Merchandiser', procurement_officer: 'Procurement', ppc_manager: 'PPC', production_supervisor: 'Production', qc_inspector: 'QC', stores_incharge: 'Stores', accounts: 'Accounts', hr: 'HR', staff: 'Staff', production_incharge: 'Production Incharge', quality_incharge: 'Quality Incharge', deroi_operator: 'Deroi', store: 'Store' };

export default function TopBar() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { user, logout } = useAuth();
  const title = TITLES[pathname] || Object.entries(TITLES).find(([p]) => pathname.startsWith(p))?.[1] || 'Khyati Portal';
  const handleLogout = async () => { await logout(); navigate('/login'); };

  return (
    <header style={{
      height: 48, minHeight: 48, background: '#fff', borderBottom: `1px solid ${C.border}`,
      display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 20px', gap: 16,
      position: 'sticky', top: 0, zIndex: 40 }}>
      <div style={{ fontSize: 15, fontWeight: 700, color: C.text, whiteSpace: 'nowrap' }}>{title}</div>
      <div style={{ flex: 1, display: 'flex', justifyContent: 'center', maxWidth: 460 }}>
        {user?.role !== 'deroi_operator' && <GlobalSearch />}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
        <NotificationBell />
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 13, color: C.text, fontWeight: 500 }}>{user?.name}</span>
          <span style={{ fontSize: 10, fontWeight: 700, color: C.navy, background: '#EEEDF8', padding: '2px 8px', borderRadius: 10, textTransform: 'uppercase', letterSpacing: 0.4 }}>{ROLE_LABEL[user?.role] || user?.role}</span>
        </div>
        <button onClick={() => navigate('/change-password')} title="Change your password" style={{ padding: '5px 12px', background: C.pageBg, border: `1px solid ${C.border}`, borderRadius: 6, fontSize: 12, cursor: 'pointer', color: C.textMuted, fontWeight: 500 }}>Change Password</button>
        <button onClick={handleLogout} style={{ padding: '5px 12px', background: C.pageBg, border: `1px solid ${C.border}`, borderRadius: 6, fontSize: 12, cursor: 'pointer', color: C.textMuted, fontWeight: 500 }}>Logout</button>
      </div>
    </header>
  );
}
